export const STYLE_OPTIONS = [
  { id: 'ghibli', label: 'Ghibli', imageUrl: '/ghibli.svg' },
  { id: 'PIXAR', label: 'Pixar', imageUrl: '/pixar.svg' },
  { id: 'DISNEY', label: 'Disney', imageUrl: '/disney.svg' },
  { id: 'MARVEL', label: 'Marvel', imageUrl: '/marvel.png' },
  { id: 'ANIME', label: 'Anime', imageUrl: '/manga.svg' },
];

export const EXTERNAL_IMAGE_TOOLS = [
  {
    id: 'image-upscale',
    text: 'Upscale Image',
    imagePath: '/upscale-icon.svg',
    link: '/upscale-image/get-started'
  },
  {
    id: 'object-remover',
    text: 'Remove Objects',
    imagePath: '/remove-icon.svg',
    link: '/object-remover/get-started'
  },
  {
    id: 'object-replacer',
    text: 'Replace Objects',
    imagePath: '/replace-icon.svg',
    link: '/object-replacer/get-started'
  },
]; 